import useFetch from "../hooks/useFetch";

const getUsuarios = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/getUsuarios', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const getPermisos = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/getPermisos', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const actualizarPermisos = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/actualizarPermisos', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const getRoles = async () => {
  try {
    return await useFetch.fnGet('seguridad/getRoles')
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const agregarUsuario = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/guardarUsuario', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const editarUsuario = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/actualizarUsuario', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const bajaUsuario = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/bajaUsuario', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const getMenus = async () => {
  try {
    return await useFetch.fnGet('seguridad/getMenus')
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const getMenuPadre = async () => {
  try {
    return await useFetch.fnGet('seguridad/getMenuPadre')
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const procesarMenu = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/procesarMenu', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const eliminarMenu = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/eliminarMenu', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

const reestablecerContrasena = async (dataRequest) => {
  try {
    return await useFetch.fnPost('seguridad/reestablecerContrasena', dataRequest)
  } catch (error) {
    console.error('Error API: ', error)
  }
}

// Exportar las funciones como un objeto
const requestApi = {
  getUsuarios,
  getPermisos,
  actualizarPermisos,
  getRoles,
  agregarUsuario,
  editarUsuario,
  bajaUsuario,
  getMenus,
  getMenuPadre,
  procesarMenu,
  eliminarMenu,
  reestablecerContrasena
}

export default requestApi;